import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import HomeSection from './components/Layout/Pages/HomeSection';
import MenuSection from './components/Layout/Pages/MenuSection';
import ContactSection from './components/Layout/Pages/ContactSection';
import Splash from './components/Layout/Pages/Splash';

function App() {
    const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSplash(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="App">
      {showSplash ? (
        <Splash />
      ) : (
      <Router>
        <Routes>
          <Route path="/" element={<Layout><HomeSection /></Layout>} />
          <Route path="/menu" element={<Layout><MenuSection /></Layout>} />
          <Route path="/location" element={<Layout><ContactSection /></Layout>} />
        </Routes>
      </Router>
       )}
    </div>
  );
}

export default App;
